export default __webpack_public_path__ + "static/media/whirpool-logo.c2ec67ee.webp";